import { z } from "zod/v4"
import { DocumentSnapshotLike } from "../firestore"
import { CreatedAt, UpdatedAt } from "./system"
import { VoiceDenormalizedTimeline, VoiceDocuments } from "./voice"

// ─── UserVoiceTimelineDocument ───────────────────────────────────────────────
// Path: user-privates/{userId}/user-voice-timeline/{entryId}
//
// フォロワーのタイムラインに非正規化されたボイス投稿のエントリ。
// story-timeline と同様の write-time fan-out パターンで、投稿作成時に
// フォロワー全員のタイムラインにコピーされる。
// 返信やエモートがつくたびに denormalize フィールドが更新される。

export const UserVoiceTimelineDocumentMeta = z.object({
  voice: VoiceDenormalizedTimeline.describe("元のボイス投稿の非正規化情報"),
})

export type UserVoiceTimelineDocumentMeta = z.infer<typeof UserVoiceTimelineDocumentMeta>

export const UserVoiceTimelineDocumentBody = z.intersection(
  UserVoiceTimelineDocumentMeta,
  z.object({
    created_at: CreatedAt,
    updated_at: UpdatedAt,
  })
)

export type UserVoiceTimelineDocumentBody = z.infer<typeof UserVoiceTimelineDocumentBody>

export const UserVoiceTimelineDocument = z.intersection(
  UserVoiceTimelineDocumentBody,
  z.object({
    id: z.string().describe("タイムラインエントリのID（自動生成）"),
  })
)

export type UserVoiceTimelineDocument = z.infer<typeof UserVoiceTimelineDocument>

export class UserVoiceTimelineDocuments {

  static toDocumentData(entry: UserVoiceTimelineDocument): object {
    return {
      ...entry,
      id: undefined,
    }
  }

  static fromDocumentSnapshot(doc: DocumentSnapshotLike | null): UserVoiceTimelineDocument | null {
    if (!doc) {
      return null
    }
    const data = doc.data()
    if (data === undefined) {
      return null
    }

    return {
      id: doc.id,
      voice: VoiceDocuments.parseDenormalizedTimeline(data["voice"]),
      created_at: data["created_at"],
      updated_at: data["updated_at"],
    }
  }

}
